export default {
  loading: false,
  allReviewsTotalCount: null,
  selectedItems: [],
  allItemsSelected: false,
  data: [],
  isAiReplyInProgress: null,
  aiLimits: { remaining_limit: 0, monthly_limit: 0 }
};
